import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-services/commerce-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Once you have the required credentials for IMS authentication, use the following cURL request to generate a new bearer token after the current token expires:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`curl --request POST \\
  --url 'https://ims-na1.adobelogin.com/ims/token/v3' \\
  --header 'Content-Type: application/x-www-form-urlencoded' \\
  --data 'grant_type=client_credentials' \\
  --data 'client_id={{client-id-value}}' \\
  --data 'client_secret={{client-secret-value}}' \\
  --data 'scope=adobeio_api,openid,AdobeID,read_organizations'
`}</code></pre>
    <p>{`Replace the following placeholders with your credentials:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`<client_id>`}</inlineCode>{`: The client ID generated for your Adobe developer project`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`<client_secret>`}</inlineCode>{`: The client secret generated for your Adobe developer project`}</li>
    </ul>
    <p>{`You can get these credentials from the Adobe Developer Console project details page. If you don't have access to the developer console, contact your system administrator for assistance.`}</p>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`For information on managing, refreshing, and revoking bearer tokens, see the `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/developer-console/docs/guides/authentication/UserAuthentication/"
      }}>{`User Authentication Implementation Guide`}</a>{` in the `}<em parentName="p">{`Adobe Developer Console documentation`}</em>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      